import React, { Component } from "react";
import style from "./card-layout.scss";

const CardLayoutHOC = (ComponentToWrap, SectionLabel, wrapperClass) => {
  class CardLayoutHOC extends Component {
    render() {
      const component = <ComponentToWrap />;
      return (
        <div className={`${style["block"]} ${wrapperClass}`}>
          <div className={style["heading"]}>{SectionLabel}</div>
          <div className={style["card-layout"]}>{component}</div>
        </div>
      );
    }
  }
  return CardLayoutHOC;
};
export default CardLayoutHOC;
